import React, { useState } from 'react';

import './footer-desk.scss';

const Footer = () => {
  return (
    <footer>
      <div className="footer-content">
        <div className="footer-links">
          <a href="https://napoveda.seznam.cz/cz/aplikace/aplikace-seznam/seznamcz-pro-pocitace/" target="_blank">Nápověda&nbsp;</a>
          <a href="https://www.seznam.cz/prohlizec/licence" target="_blank">&nbsp;Smluvní podmínky&nbsp;</a>
          <a href="https://www.seznam.cz/prohlizec/historie-zmen/win" target="_blank">&nbsp;Historie změn</a>
        </div>
        <div className="copyright">Copyright © 1996–2019 Seznam.cz, a. s.</div>
      </div>
    </footer>
  );
};


class FooterDesk extends React.PureComponent {
  render() {
    return (
      <Footer />
    );
  }
}

export default FooterDesk;
